<template>
	<v-flex xs12>
		<v-card>
			<v-card-title>
				<v-flex xs12 class="mb-5">
					<h4>{{ pageTitle }}</h4>
				</v-flex>
				<v-flex xs12>
					<v-form ref="form" lazy-validation @submit.prevent="submit">
						<v-container grid-list-xl>
							<v-layout wrap>
								<v-flex xs12 md6>
									<v-text-field
										v-model="name"
										name="name"
										label="Name"
										:counter="100"
										v-validate="'required|max:100'"
										data-vv-as="Name"
										:error-messages="errors.collect('name')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 md6>
									<v-text-field
										v-model="birthInfo"
										name="birthInfo"
										label="Date Info"
										:counter="100"
										v-validate="'required|max:100'"
										data-vv-as="Date Info"
										:error-messages="errors.collect('birthInfo')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 md6>
									<v-text-field
										v-model="address"
										name="address"
										label="Address"
										:counter="500"
										v-validate="'required|max:500'"
										data-vv-as="Address"
										:error-messages="errors.collect('address')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 md6>
									<v-text-field
										v-model="designation"
										name="designation"
										label="Designation"
										:counter="1000"
										v-validate="'required|max:1000'"
										data-vv-as="Designation"
										:error-messages="errors.collect('designation')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 md6>
									<v-text-field
										v-model="priority"
										name="priority"
										label="Priority"
										v-validate="'required|numeric'"
										data-vv-as="Priority"
										:error-messages="errors.collect('priority')"
									></v-text-field>
								</v-flex>
								<v-flex xs12 md12>
									<div class="v-list-item__subtitle">Info</div>
									<quill-editor
										v-model="info"
										name="info"
										ref="myQuillEditor"
										v-validate="'required'"
										:options="editorOption"
										data-vv-as="Info"
										:error-messages="errors.collect('info')"
									></quill-editor>
									<div
										class="v-text-field__details"
										v-show="errors.has('info')"
									>
										<div class="v-messages theme--light error--text">
											<div class="v-messages__wrapper">
												<div class="v-messages__message">
													{{ errors.first("info") }}
												</div>
											</div>
										</div>
									</div>
								</v-flex>
								<v-flex xs12 md1>
									<v-btn color="info" type="button" @click="imagePicked">
										<v-icon>cloud_upload</v-icon>
										Image
									</v-btn>
									<input
										type="file"
										style="display: none"
										ref="ImageUploader"
										accept="image/*"
										@change="onImagePicked"
									/>
								</v-flex>
								<v-flex xs12 md4>
									<vue-cropper
										ref="cropper"
										:aspect-ratio="ratio"
										:src="mainImage"
										:imageSmoothingEnabled="false"
										alt="Upload Image"
									></vue-cropper>
									<!-- <img :src="image" style="width:100%" v-if="image" /> -->
									<br />
									<v-btn
										color="info"
										type="button"
										@click="crop"
										v-if="showCrop"
									>
										<v-icon>crop</v-icon>
										Crop
									</v-btn>
								</v-flex>
								<v-flex xs12 md4>
									<img
										v-if="image"
										:src="image"
										alt="Cropped Image"
										style="width: 100%"
									/>
								</v-flex>
							</v-layout>
						</v-container>
						<v-divider class="mt-5"></v-divider>
						<v-card-actions>
							<v-btn color="success" type="submit">
								<v-icon>save</v-icon>
								Save
							</v-btn>
							<v-btn color="error" @click="reset">Reset</v-btn>
						</v-card-actions>
					</v-form>
				</v-flex>
			</v-card-title>
		</v-card>
	</v-flex>
</template>

<script>
	import store from "../../store";
	import commonservice from "../../shared/common.service";
	import VueCropper from "vue-cropperjs";
	import "cropperjs/dist/cropper.css";

	export default {
		components: { VueCropper },
		computed: {
			name: {
				get() {
					return this.$store.state.ourTeam.entity.name;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "name",
						value: val,
					});
				},
			},
			info: {
				get() {
					return this.$store.state.ourTeam.entity.info;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "info",
						value: val,
					});
				},
			},
			address: {
				get() {
					return this.$store.state.ourTeam.entity.address;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "address",
						value: val,
					});
				},
			},
			birthInfo: {
				get() {
					return this.$store.state.ourTeam.entity.birthInfo;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "birthInfo",
						value: val,
					});
				},
			},
			designation: {
				get() {
					return this.$store.state.ourTeam.entity.designation;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "designation",
						value: val,
					});
				},
			},
			image: {
				get() {
					return this.$store.state.ourTeam.entity.image;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "image",
						value: val,
					});
				},
			},
			mainImage: {
				get() {
					return this.$store.state.ourTeam.mainImage;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", val);
				},
			},
			priority: {
				get() {
					return this.$store.state.ourTeam.entity.priority;
				},
				set(val) {
					this.$store.commit("ourTeam/SET_DATA", {
						key: "priority",
						value: val,
					});
				},
			},
		},
		data() {
			return {
				pageTitle: "Add Team Member",
				loading: false,
				menu: {
					publishDate: false,
				},
				menu1: false,
				ratio: 1.29,
				showCrop: false,
				editorOption: {
					// some quill options
				},
			};
		},
		beforeRouteEnter(to, from, next) {
			if (to.params.id) {
				store.dispatch("ourTeam/set", { id: to.params.id }).then(() => {
					next((p) => {
						p.pageTitle = "Edit Team Member";
					});
				});
			} else {
				next((p) => {
					p.reset();
				});
			}
		},
		methods: {
			submit() {
				if (this.loading) return;
				if (this.image == null) {
					commonservice.showErrorMessage("Please upload image");
					return;
				}
				this.$validator.validateAll().then((valid) => {
					if (valid) {
						this.loading = true;
						this.$store
							.dispatch("ourTeam/save")
							.then(
								() => {
									commonservice.showSuccessMessage(
										"Team member saved successfully"
									);
									this.$router.push("/ourTeam");
									this.loading = false;
								},
								() => {
									this.loading = false;
								}
							)
							.catch(() => {
								this.loading = false;
							});
					}
				});
			},
			reset() {
				this.$store.commit("ourTeam/RESET");
				setTimeout(() => {
					this.errors.clear();
				}, 10);
			},
			remove(item) {
				console.log(item);
				// this.chips.splice(this.chips.indexOf(item), 1);
				// this.chips = [...this.chips];
			},
			imagePicked() {
				this.$refs.ImageUploader.click();
			},
			crop() {
				var self = this;
				// get image data for post processing, e.g. upload or setting image src
				var cropIm = self.$refs.cropper
					.getCroppedCanvas({ imageSmoothingEnabled: false })
					.toDataURL("image/jpeg", 0.7);
				self.$store.commit("ourTeam/SET_DATA", {
					key: "image",
					value: cropIm,
				});
			},
			onImagePicked(event) {
				var reader = new FileReader();
				reader.readAsDataURL(event.target.files[0]);
				var self = this;
				reader.onload = function () {
					self.$store.commit("ourTeam/SET_MAIN_IMAGE", reader.result);
					self.$refs.cropper.replace(reader.result);
					self.showCrop = true;
				};
			},
		},
	};
</script>
